// libs
import { connect } from 'react-redux';
import { withDataFetching } from 'shared/helpers/dataFetching';
import isEmpty from 'lodash/isEmpty';

// selectors
import { getSSRHeaders } from 'shared/store/app/selectors';
import {
  isFetching,
  isFetchingError,
  isNotFound,
  getLandingPageData,
  getErrorStatusCode,
} from 'shared/store/landingpage/selectors';

// store
import { fetchLandingpageData as _fetchLandingpageData } from 'shared/store/landingpage/services';
import { notFound as _notFound } from 'shared/store/landingpage/actions';
import { updateStatusCode as _updateStatusCode } from 'shared/store/app/actions';

// defs
import {
  ILandingPageStateProps,
  ILandingPageDispatchProps,
  ILandingPageProps,
} from 'shared/layouts/LandingPage/types';

// components
import API from './API';

// helpers
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

const mapStateToProps = (state: any) => {
  return {
    landingPageData: getLandingPageData(state),
    ssrHeaders: getSSRHeaders(state),
    isFetchingError: isFetchingError(state),
    isFetching: isFetching(state),
    isNotFound: isNotFound(state),
    errorStatusCode: getErrorStatusCode(state),
    shouldFetchAdPlatformV2: getRemoteConfig(state, 'enablePLPFetchAdplatformV2'),
  };
};

const mapDispatchToProps = {
  fetchLandingpageData: _fetchLandingpageData,
  updateStatusCode: _updateStatusCode,
  notFound: _notFound,
};

const fetchData = async ({
  landingPageData,
  fetchLandingpageData,
  ssrHeaders,
  pageName,
  updateStatusCode,
  notFound,
  shouldTransformForDealsPlatform,
  shouldFetchAdPlatformV2 = false,
}: ILandingPageProps) => {
  if (isEmpty(pageName)) {
    updateStatusCode(404);
    return Promise.resolve(notFound());
  }

  if (isEmpty(landingPageData)) {
    const headers = __SERVER__ ? ssrHeaders : {};

    return fetchLandingpageData(
      headers,
      pageName,
      shouldTransformForDealsPlatform,
      shouldFetchAdPlatformV2
    ).catch((err: { status: number }) => {
      if (err.status === 404) {
        updateStatusCode(404);
      } else {
        updateStatusCode(500);
      }
    });
  }
};

export default connect<ILandingPageStateProps, ILandingPageDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(withDataFetching(fetchData)(API));
